export const WIDGET_API_ERROR_CHANNEL_NOT_FOUND = 'channel_not_found';
